<template>
  <div class="main-container">
    <div class="bread" v-if="!!$route.query.recommend">
      <router-link :to="{ name: 'Index' }">首页</router-link>
      <span class="slash">/</span>
      <span class="current">{{ $route.query.title }}</span>
    </div>
    <div class="bread" v-else-if="$route.query.type == 4">
      <router-link :to="{ name: 'Index' }">首页</router-link>
      <span class="slash">/</span>
      <span class="current">公开课</span>
    </div>
    <Classify
      class="classify"
      :class="{ 'classify-top': !$route.query.recommend }"
      :items="classifyItems"
      @change="onClassifyChange"
    ></Classify>
    <ListSort v-if="!recommend" v-model="sort"></ListSort>
    <List
      class="list"
      ref="list"
      url="/api/app/courseBasis"
      :search="params"
      :limit="15"
      :alwaysShowPager="true"
    >
      <template v-slot="{ list }">
        <div class="course-list clearfix">
          <template v-for="course in list">
            <RichCourseItem :key="course.id" :course="course"></RichCourseItem>
          </template>
        </div>
        <Empty
          v-if="list.length == 0"
          class="empty"
          title="暂无课程安排，敬请期待！"
        />
      </template>
    </List>
  </div>
</template>
<script>
import List from "@/components/List.vue";
import RichCourseItem from "../../components/rich/CourseItem.vue";
import Classify from "../../components/Classify.vue";
import ListSort from "@/modules/stu/components/ListSort.vue";

export default {
  name: "Course",
  components: {
    List,
    Classify,
    RichCourseItem,
    ListSort,
  },
  data() {
    return {
      courseTypes: [],
      classifyList: [],
      classify: 0,
      subClassify: 0,
      attrCondition: {},
      attrs: [],
      courseClassifyData: {},
      sort: 0,
      courseType: this.$route.query.type || 0,
      recommend: this.$route.query.recommend,
    };
  },
  computed: {
    keywords() {
      return this.$store.state.search;
    },
    commonSetting() {
      return this.$store.state.commonSetting;
    },
    classifyItems() {
      let items = [];
      items.push({
        id: "classify",
        name: "课程分类",
        value: { item: this.classify, child: this.subClassify },
        children: this.classifyList,
      });
      this.attrs.forEach(c => {
        let item = {
          id: c.id,
          name: c.name,
          value: { item: this.attrCondition[c.id] },
          children: c.child,
        };
        items.push(item);
      });
      if (
        (this.$route.path != "/course/type" || this.courseTypes.length > 2) &&
        !(this.$route.query.type == 4)
      ) {
        items.push({
          id: "type",
          name: "类型",
          value: { item: this.courseType },
          children: this.courseTypes.map(t => {
            return { id: t.key, name: t.value };
          }),
        });
      }
      return items;
    },
    params() {
      let params = {
        course_type: this.courseType > 0 ? this.courseType : 0,
        classify_id: this.subClassify || this.classify,
        is_vip: this.courseType == -1 ? 1 : 0,
        keywords: this.keywords,
        order_by: this.sort,
      };
      if (this.$route.query.nav) {
        params.nav_id = this.$route.query.nav;
      }
      let attrValIds = [];
      for (let key in this.attrCondition) {
        let valId = this.attrCondition[key];
        if (valId != 0) {
          attrValIds.push(valId);
        }
      }
      params.attr_val_id = attrValIds.join(",");
      if (this.$route.query.recommend) {
        params.recommend = this.$route.query.recommend;
      }
      return params;
    },
  },
  watch: {
    keywords: async function () {
      await this.getCourse(true);
    },
    commonSetting() {
      this.buildCourseType();
    },
    async $route() {
      await this.$nextTick();
      this.init();
      await this.getClassify();
      this.courseType = this.$route.query.type || 0;
      await this.getCourse(true);
    },
    sort() {
      this.getCourse(true);
    },
  },
  async created() {
    this.init();
    await this.getClassify();
  },
  methods: {
    init() {
      this.classify = 0;
      this.subClassify = 0;
      this.course_type = this.$route.query.type || 0;
      this.recommend = this.$route.query.recommend;
    },
    buildCourseType() {
      let courseTypes = [];
      this.courseClassifyData.appCourseType.forEach(t => {
        courseTypes.push({
          key: t.id,
          value: t.name,
        });
      });
      if (this.courseClassifyData.vipCourseCount > 0) {
        courseTypes.push({
          key: "-1",
          value: "会员课",
        });
      }
      this.courseTypes = courseTypes;
    },
    async getClassify() {
      let params = {};
      if (this.$route.query.nav) {
        params.nav_id = this.$route.query.nav;
      }
      if (this.$route.query.recommend) {
        params.recommend = this.$route.query.recommend;
      }
      let data = await this.$http.get("/api/app/courseClassify", params);
      data.classify.unshift({ id: 0, name: "全部" });
      data.classify.forEach(c => {
        if (!c.children) {
          return;
        }
        c.children.unshift({ id: 0, name: "全部" });
      });
      this.classifyList = data.classify;
      this.courseClassifyData = data;
      let attrs = data.attrclassify;
      attrs.forEach(attr => {
        attr.child.unshift({
          id: 0,
          name: "全部",
        });
        this.$set(this.attrCondition, attr.id, 0);
      });
      this.attrs = attrs;

      this.buildCourseType();
    },
    getCourse(refresh = false) {
      if (refresh) {
        this.$refs.list.searchRefresh();
      }
    },
    onClassifyChange({ id, value }) {
      if (id == "type") {
        this.courseType = value.item;
      } else if (id == "classify") {
        this.classify = value.item;
        this.subClassify = value.child;
      } else {
        this.attrCondition[id] = value.item;
      }
      this.getCourse(true);
    },
  },
};
</script>
<style lang="scss" scoped>
.classify {
  margin: 0;
}

.classify-top {
  margin-top: 24px;
}

.empty {
  margin-bottom: 30px;
}

/deep/ .el-pagination {
  margin: 16px 0 46px 0;
}

.course-list {
  /deep/ {
    .item {
      margin-bottom: 30px;
    }
  }
}
</style>
